
import './App.css';
import NavBar from './components/NavBar';
import Home from './pages/Home';
import { Routes, Route, Navigate } from 'react-router-dom';
import Gallery from './pages/Gallery';
import AboutUs from './pages/AboutUs';
import SchedulePage from './pages/SchedulePage';
import Memberships from './pages/Memberships';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';



const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
  typography: {

    h3: {
      fontWeight:500,
      letterSpacing: "0.05em",
      lineHeight:1.8,
    }, 

    h6: {
      lineHeight:1.8,
    },

    subtitle1: {
      lineHeight:1.8,
      fontSize:19.2,
      fontWeight: 'bold',
    },

    body1: {
      lineHeight:1.8,
    },
  }
  });

// darkTheme.spacing(2);

function App() {
  

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div className="App" >
        <NavBar/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/home" element={<Home/>}/>
        <Route path="/about" element={<AboutUs/>}/>
        <Route path="/schedule" element={<SchedulePage/>}/>
        <Route path="/contact-us" element={<Contact/>}/>
        <Route path="/memberships" element={<Memberships/>}/>
        <Route path="/gallery" element={<Gallery/>}/>
        
        {/* Old WordPress URL redirects  */}
        <Route path="/coaches/*" element={<Navigate to="/about" replace />}/>
        <Route path="/gym/*" element={<Navigate to="/about" replace />}/>
        <Route path="/classes/*" element={<Navigate to="/schedule" replace />}/>
        <Route path="/photogallery/*" element={<Navigate to="/gallery" replace />}/>
        <Route path="/schedule-classes/*" element={<Navigate to="/schedule" replace />}/>
        <Route path="/membership/*" element={<Navigate to="/memberships" replace />}/>
        <Route path="/2015_05-submission-ace-athletes/*" element={<Navigate to="/" replace />}/>
        <Route path="/timetable/*" element={<Navigate to="/schedule" replace />}/>
        <Route path="/timetable-testing/*" element={<Navigate to="/schedule" replace />}/>
        <Route path="/gallerycategory/*" element={<Navigate to="/gallery" replace />}/>
        <Route path="/competitions/*" element={<Navigate to="/gallery" replace />}/>

        <Route path="*" element={<NotFound/>}/>
      </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
